import type { GameSnapshot } from '../types';

interface WaitingRoomProps {
  snapshot: GameSnapshot;
  currentPlayerId: string;
  onReady: () => void;
  onStartSolo: () => void;
}

export function WaitingRoom({ snapshot, currentPlayerId, onReady, onStartSolo }: WaitingRoomProps) {
  const me = snapshot.players.find((player) => player.id === currentPlayerId);
  const readyCount = snapshot.players.filter((player) => player.ready).length;
  const alone = snapshot.players.length === 1;

  return (
    <section className="waiting-room" aria-label="Waiting room">
      <h2>Waiting room</h2>
      <p>
        {alone
          ? 'Share the join link, or start solo if you don’t want to wait.'
          : "The game starts as soon as everyone is ready. Once it starts, the game is locked to these players — start a new game to change who's playing."}
      </p>
      <div className="players-list">
        {snapshot.players.map((player) => (
          <div className="player-row" key={player.id}>
            <span className={`status-dot ${player.status}`} />
            <span>
              {player.name}
              {player.id === currentPlayerId ? ' (you)' : ''}
            </span>
            <strong className={`ready-badge ${player.ready ? 'is-ready' : ''}`}>
              {player.ready ? '✓ Ready' : 'Not ready'}
            </strong>
          </div>
        ))}
      </div>
      <button disabled={!me || me.ready} onClick={onReady} type="button">
        {me?.ready ? 'Waiting for others…' : "I'm ready"}
      </button>
      {alone && (
        <button className="ghost-button" onClick={onStartSolo} type="button">
          Start solo
        </button>
      )}
      <small>
        {readyCount} of {snapshot.players.length} ready
      </small>
    </section>
  );
}
